module.exports = __webpack_public_path__ + "static/desktop.67f2d217.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/desktop.png
// module id = 510
// module chunks = 268472206294114